import Vue from 'vue'

const kib = Vue.$cookies.get('kib')
const menu = {
  B: [
    {
      title: 'Dashboard',
      route: 'bDashboard',
      icon: 'HomeIcon',
      action: 'Lihat',
      resource: 'b-dashboard',
    },
    {
      title: 'Master',
      icon: 'ToolIcon',
      action: 'Lihat',
      resource: 'master',
      children: [
        {
          title: 'Jenis Ruangan',
          route: 'masterJenisRuangan',
          resource: 'master-jenis-ruangan',
          action: 'Lihat',
        },
      ],
    },
    {
      title: 'SK Tim',
      route: 'bSkTim',
      icon: 'UsersIcon',
      action: 'Lihat',
      resource: 'b-sk-tim',
    },
    {
      title: 'Ruangan',
      route: 'bRuangan',
      resource: 'b-ruangan',
      action: 'Lihat',
      icon: 'LockIcon',
    },
    {
      title: 'Daftar BMD',
      route: 'bDaftarBmd',
      icon: 'TruckIcon',
      action: 'Lihat',
      resource: 'b-daftar-bmd',
    },
    {
      title: 'Pendalaman Register',
      route: 'bPendalamanRegister',
      icon: 'ArchiveIcon',
      action: 'Lihat',
      resource: 'b-pendalaman-register',
    },
    {
      title: 'Validasi Pendataan & Pendalaman',
      route: 'bHasilSensus',
      icon: 'BookIcon',
      action: 'Lihat',
      resource: 'b-hasil-sensus',
    },
    {
      title: 'Monitoring',
      route: 'bMonitoring',
      icon: 'PieChartIcon',
      action: 'Lihat',
      resource: 'b-monitoring',
    },
    {
      title: 'Perkin',
      route: 'bPerkin',
      icon: 'ActivityIcon',
      action: 'Lihat',
      resource: 'b-perkin',
    },
    {
      title: 'Tim Inventarisasi (BA)',
      route: 'bBeritaAcaraHasilInventarisasi',
      icon: 'FileTextIcon',
      action: 'Lihat',
      resource: 'b-berita-acara-hasil-inventarisasi',
    },
    {
      title: 'Dokumen Inventarisasi',
      route: 'bDokumenInventarisasi',
      icon: 'FileTextIcon',
      action: 'Lihat',
      resource: 'b-dokumen-inventarisasi',
    },
    {
      title: 'Log',
      route: 'generalLog',
      icon: 'GitCommitIcon',
      action: 'Lihat',
      resource: 'general-log',
    },
  ],
  C: [
    {
      title: 'Dashboard',
      route: 'cDashboard',
      icon: 'HomeIcon',
      action: 'Lihat',
      resource: 'c-dashboard',
    },
    {
      title: 'Monitoring',
      route: 'cMonitoring',
      icon: 'PieChartIcon',
      action: 'Lihat',
      resource: 'c-monitoring',
    },
    {
      title: 'Perkin',
      route: 'perkin',
      icon: 'ActivityIcon',
      action: 'Lihat',
      resource: 'perkin',
    },
    {
      title: 'Cetak Daftar BMD',
      route: 'cetakDaftarBmd',
      icon: 'DownloadCloudIcon',
      action: 'Lihat',
      resource: 'cetakDaftarBmd',
    },
    {
      title: 'Cetak Barcode',
      route: 'cetakBarcode',
      icon: 'DownloadIcon',
      action: 'Lihat',
      resource: 'cetakBarcode',
    },
    {
      title: 'Keberadaan',
      route: 'validasiKeberadaan',
      icon: 'CheckSquareIcon',
      action: 'Lihat',
      resource: 'validasiKeberadaan',
    },
    {
      title: 'Data Informasi',
      route: 'dataInformasi',
      icon: 'ListIcon',
      action: 'Lihat',
      resource: 'dataInformasi',
    },
    {
      title: 'Cetak QR Code',
      route: 'cetakQrCode',
      icon: 'DownloadIcon',
      action: 'Lihat',
      resource: 'cetakQrCode',
    },
    {
      title: 'BMD Belum Tercatat',
      route: 'validasiBelumTercatat',
      icon: 'CheckSquareIcon',
      action: 'Lihat',
      resource: 'validasiBelumTercatat',
    },
    {
      title: 'Laporan',
      route: 'laporan',
      icon: 'FileTextIcon',
      action: 'Lihat',
      resource: 'laporan',
    },
    {
      title: 'SPTJM',
      route: 'sptjm',
      icon: 'FileTextIcon',
      action: 'Lihat',
      resource: 'sptjm',
    },
    {
      title: 'Berita Acara',
      route: 'beritaAcara',
      icon: 'FileTextIcon',
      action: 'Lihat',
      resource: 'beritaAcara',
    },
    {
      title: 'Koreksi',
      icon: 'CoffeeIcon',
      action: 'Lihat',
      resource: 'koreksi',
      children: [
        {
          title: 'Status Inventarisasi',
          route: 'koreksiPengembalian',
          resource: 'koreksi-pengembalian',
          action: 'Lihat',
        },
        {
          title: 'Data Inventarisasi',
          route: 'koreksiCleansing',
          resource: 'koreksi-cleansing',
          action: 'Lihat',
        },
      ],
    },
  ],
}

export default menu[kib]
